'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var common = {
  perspective: 1000,
  transformStyle: 'preserve-3d',
  backfaceVisibility: 'hidden'
};

var appear = exports.appear = function appear() {
  return _extends({}, common, {
    rotateX: -180,
    opacity: 0
  });
};

var appeared = exports.appeared = function appeared() {
  return _extends({}, common, {
    rotateX: 0,
    opacity: 1
  });
};

var enter = exports.enter = appeared;

var entered = exports.entered = appeared;

var leaved = exports.leaved = appear;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(common, 'common', 'src/animations/transitions/flip.js');

  __REACT_HOT_LOADER__.register(appear, 'appear', 'src/animations/transitions/flip.js');

  __REACT_HOT_LOADER__.register(appeared, 'appeared', 'src/animations/transitions/flip.js');

  __REACT_HOT_LOADER__.register(enter, 'enter', 'src/animations/transitions/flip.js');

  __REACT_HOT_LOADER__.register(entered, 'entered', 'src/animations/transitions/flip.js');

  __REACT_HOT_LOADER__.register(leaved, 'leaved', 'src/animations/transitions/flip.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/react-stack-grid/lib/animations/transitions/flip.js
// module id = 539
// module chunks = 35783957827783